import { ROOT_URL } from '../actions';

export const commonApi = {
  GET_SESSION_ID: `${ROOT_URL}/hms/session/`,
  GET_RECIPIENTS: `${ROOT_URL}/hms/get_recipients/`,
  GET_SHIPMENT_NUMBERS_LIST: `${ROOT_URL}/hms/shipments/`,
  DOWNLOAD_SHIPMENT_MANIFEST: `${ROOT_URL}/hms/download-shipment-manifest/`
}